// Mock data for Urban Cage landing page

// Hero assets
export const heroAssets = {
  video: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/7gbc3xq8_Firefly%20Create%20a%205%E2%80%937%20second%20cinematic%20luxury%20tech%20motion%20video%20featuring%20a%20premium%20modular%20sports%20ca.mp4',
  staticImage: 'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/qz02s567_%D0%A3%D1%87%D0%B8%D0%BB%D0%B8%D1%89%D0%B5.%D0%A2%D0%B5%D0%BD%D0%B8%D1%813jpg',
  logo: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/wf7skvh8_LOGO.png'
};

// New redesigned drawings (batch 1) — remaining sizes use group placeholder until real files arrive
const drawingUC16_1 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/hyeykz3z_UC16.1-54m2.png';
const drawingUC16_2 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/z3ggt9dx_UC16.2-60m2.png';
const drawingUC20_1 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/0v4dkyr4_UC20.1-76m2.png';
const drawingUC20_2 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/kb6nh0gg_UC20.2-83m2.png';
const drawingUC20_3 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/mv6lcptf_UC20.3-87m2.png';
const drawingUC20_4 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/2b43lpuw_UC20.4-87m2.png';
const drawingUC20_5 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/d2s20vrw_UC20.5-86m2.png';
const drawingUC24_1 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/cwayrmd2_UC24.1-94m2.png';
const drawingUC24_2 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/wpum4hj4_UC24.2-105m2.png';
const drawingUC24_3 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/duv2y3hk_UC24.3-114m2.png';
const drawingUC24_4 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/83wye2op_UC24.4-113m2.png';
const drawingUC24_5 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/r1rnjx63_UC24.5-122m2.png';
const drawingUC24_6 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/0vc8bbk3_UC24.6-118m2.png';
const drawingUC24_7 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/tikby288_UC24.7-120m2.png';
const drawingUC28_1 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/zkdfta9f_UC28.1-107m2.png';
const drawingUC28_2 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/0znf2cnu_UC28.2-128m2.png';
const drawingUC28_3 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/jyrdl2d7_UC28.3-141m2.png';
const drawingUC28_4 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/nj9z4sj7_UC28.4-149m2.png';
const drawingUC28_5 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/k1v42st2_UC28.5-138m2.png';
const drawingUC28_6 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/97wq02g0_UC28.6-153m2.png';
const drawingUC28_7 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/ay9sjoba_UC28.7-159m2.png';
const drawingUC28_8 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/optcde9a_UC28.8-155m2.png';
const drawingUC28_9 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/wmt8w504_UC28.9-161m2.png';
const drawingUC28_10 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/f816dfmw_UC28.10-157m2.png';
const drawingUC30 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/yni1xeax_UC30-177m2.png';
const drawingUC32 = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/il5degn9_UC32-200m2.png';
const drawingRect = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/scrpuj9e_UCRectangular-cage.png';

// Logo overlaid via CSS on logo-free drawings (overlayLogo: true)
export const configuratorLogo = 'https://customer-assets-eiarnc6j.emergentagent.net/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/uv51l2w8_UrbanCage_Logo-configurator.webp';

export const modelSizes = [
  {
    model: 'UC16',
    areaRange: '55–60 m²',
    sizes: [
      { variant: 'UC16.1', size: '55 m²', sqm: 55, dimensions: '11.20 x 5.80 m', image: drawingUC16_1, overlayLogo: true },
      { variant: 'UC16.2', size: '60 m²', sqm: 60, dimensions: '10.62 x 7.54 m', image: drawingUC16_2, overlayLogo: true }
    ]
  },
  {
    model: 'UC20',
    areaRange: '76–87 m²',
    sizes: [
      { variant: 'UC20.1', size: '76 m²', sqm: 76, dimensions: '14.20 x 5.80 m', image: drawingUC20_1, overlayLogo: true },
      { variant: 'UC20.2', size: '83 m²', sqm: 83, dimensions: '13.63 x 7.57 m', image: drawingUC20_2, overlayLogo: true },
      { variant: 'UC20.3', size: '87 m²', sqm: 87, dimensions: '13.05 x 9.32 m', image: drawingUC20_3, overlayLogo: true },
      { variant: 'UC20.4', size: '87 m²', sqm: 87, dimensions: '12.09 x 8.66 m', image: drawingUC20_4, overlayLogo: true },
      { variant: 'UC20.5', size: '86 m²', sqm: 86, dimensions: '9.98 x 11.51 m', image: drawingUC20_5, overlayLogo: true }
    ]
  },
  {
    model: 'UC24',
    areaRange: '94–122 m²',
    sizes: [
      { variant: 'UC24.1', size: '94 m²', sqm: 94, dimensions: '17.20 x 5.80 m', image: drawingUC24_1, overlayLogo: true },
      { variant: 'UC24.2', size: '105 m²', sqm: 105, dimensions: '16.63 x 7.57 m', image: drawingUC24_2, overlayLogo: true },
      { variant: 'UC24.3', size: '114 m²', sqm: 114, dimensions: '16.05 x 9.32 m', image: drawingUC24_3, overlayLogo: true },
      { variant: 'UC24.4', size: '113 m²', sqm: 113, dimensions: '15.09 x 8.66 m', image: drawingUC24_4, overlayLogo: true },
      { variant: 'UC24.5', size: '122 m²', sqm: 122, dimensions: '14.52 x 10.42 m', image: drawingUC24_5, overlayLogo: true },
      { variant: 'UC24.6', size: '118 m²', sqm: 118, dimensions: '15.47 x 11.08 m', image: drawingUC24_6, overlayLogo: true },
      { variant: 'UC24.7', size: '120 m²', sqm: 120, dimensions: '13.08 x 11.61 m', image: drawingUC24_7, overlayLogo: true }
    ]
  },
  {
    model: 'UC28',
    areaRange: '107–161 m²',
    sizes: [
      { variant: 'UC28.1', size: '107 m²', sqm: 107, dimensions: '20.30 x 5.90 m', image: drawingUC28_1, overlayLogo: true },
      { variant: 'UC28.2', size: '128 m²', sqm: 128, dimensions: '19.73 x 7.67 m', image: drawingUC28_2, overlayLogo: true },
      { variant: 'UC28.3', size: '141 m²', sqm: 141, dimensions: '19.15 x 9.42 m', image: drawingUC28_3, overlayLogo: true },
      { variant: 'UC28.4', size: '149 m²', sqm: 149, dimensions: '18.58 x 11.18 m', image: drawingUC28_4, overlayLogo: true },
      { variant: 'UC28.5', size: '138 m²', sqm: 138, dimensions: '18.19 x 8.76 m', image: drawingUC28_5, overlayLogo: true },
      { variant: 'UC28.6', size: '153 m²', sqm: 153, dimensions: '17.62 x 10.52 m', image: drawingUC28_6, overlayLogo: true },
      { variant: 'UC28.7', size: '159 m²', sqm: 159, dimensions: '17.05 x 12.27 m', image: drawingUC28_7, overlayLogo: true },
      { variant: 'UC28.8', size: '155 m²', sqm: 155, dimensions: '16.08 x 11.61 m', image: drawingUC28_8, overlayLogo: true },
      { variant: 'UC28.9', size: '161 m²', sqm: 161, dimensions: '15.51 x 13.38 m', image: drawingUC28_9, overlayLogo: true },
      { variant: 'UC28.10', size: '157 m²', sqm: 157, dimensions: '13.98 x 14.44 m', image: drawingUC28_10, overlayLogo: true }
    ]
  },
  {
    model: 'UC30',
    areaRange: '116–181 m²',
    sizes: [
      { variant: 'UC30', size: '177 m²', sqm: 177, dimensions: '17.62 x 10.52 m', image: drawingUC30, overlayLogo: true }
    ]
  },
  {
    model: 'UC32',
    areaRange: '125–200 m²',
    sizes: [
      { variant: 'UC32', size: '200 m²', sqm: 200, dimensions: '18.51 x 13.39 m', image: drawingUC32, overlayLogo: true }
    ]
  },
  {
    model: 'RECT',
    nameKey: 'modelRect',
    sizes: [
      { variant: 'RECT', size: 'custom', sizeKey: 'sizeCustom', sqm: 0, dimensions: null, image: drawingRect, overlayLogo: true }
    ]
  }
];

// Upgrade add-ons
export const upgradeAddons = [
  { id: 'fitness', name: 'addonFitness' },
  { id: 'solar_led', name: 'addonSolarLED' },
  { id: 'bench', name: 'addonBench' },
  { id: 'trash', name: 'addonTrash' }
];

export const galleryImages = [
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/oiwao24g_MD403780.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/2ywvjgz7_MD403723.jpg',
  'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/9b0arkge_MD403893.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/os1prpcj_MD403875.jpg',
  'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/3uyvpoqf_MD403897.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/dy44vp3c_DJI_0034.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/j75us9sc_DJI_0022.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/p3bae7g2_DJI_0017.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/g6lk9ach_MD403874.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/iyycji9w_MD403887.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/0peb3mwg_MD403796.jpg',
  'https://customer-assets.emergentagent.com/job_multisport-hub-4/artifacts/y58klsxg_MD403864.jpg',
  // Batch 1 - new gallery images
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/xm6xrtw2_UrbanCage-site.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/zyrdqz8u_UrbanCage_Ruse.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/4orfzjsa_UrbanCage_Chiprovci.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/58pyqhsk_UrbanCage_Montana.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/h6ytfpjv_UrbanCage_Montana2.jpg',
  // Batch 2 - new gallery images
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/ac4n01eo_UrbanCage3.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/2u4wu0j5_UrbanCage_Simitli.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/845vrg2x_UrbanCage_Simitli2.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/6y8upuct_UrbanCage_SeparevaBanq.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/d0kei0sd_UrbanCage_4.jpg',
  // Batch 3 - new gallery images
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/fdlzyrn3_UrbanCage_beach.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/14sbdild_UrbanCage_sarbia1.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/45firea9_UrbanCage_sarbia2.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/nwkn00bc_UrbanCage_Chiprovci3.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/yok79dv2_UrbanCage3.jpg',
  // Batch 4 - new gallery images (Chiprovci series)
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/g3c4ta3b_UrbanCage_Chiproci100.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/2rubxap7_UrbanCage_Chiproci101.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/v1ysfrg8_UrbanCage_Chiproci102.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/1iojn2f6_UrbanCage_Chiproci103.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/92utx18g_UrbanCage_Chiproci104.jpg',
  // Batch 5 - new gallery images (UrbanCage 200 series)
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/a1jl5e7j_UrbanCage_200.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/dpqb3rdf_UrbanCage_202.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/cgorlume_UrbanCage_203.jpg',
  'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/jypu2zjx_UrbanCage_204.jpg'
];

export const colorCombinations = [
  { 
    id: 'obsidian-amber', 
    name: 'obsidianAmber', 
    colors: { primary: '#0A0A0A', accent: '#E94B0F' }, // Jet Black + Orange
    ralCode: 'RAL 9005'
  },
  { 
    id: 'slate-blaze', 
    name: 'slateBlaze', 
    colors: { primary: '#383E42', accent: '#E94B0F' }, // Asphalt Grey + Orange
    ralCode: 'RAL 7016'
  },
  { 
    id: 'forest-fire', 
    name: 'forestFire', 
    colors: { primary: '#2F4538', accent: '#E94B0F' }, // Moss Green + Orange
    ralCode: 'RAL 6005'
  },
  { 
    id: 'ocean-gold', 
    name: 'oceanGold', 
    colors: { primary: '#9BA3A8', accent: '#E94B0F' }, // Concrete Grey + Orange
    ralCode: 'RAL 7040'
  }
];

export const surfaceSystems = [
  { 
    id: 'none', 
    name: 'noFlooring', 
    description: 'noFlooringDesc',
    image: 'https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/o558wpeh_bez-nastilka.png'
  },
  { 
    id: 'acrylic', 
    name: 'acrylicSurface', 
    description: 'acrylicDesc',
    image: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/81l0efuj_Acrylic.png'
  },
  { 
    id: 'sbr', 
    name: 'sbrRubber', 
    description: 'sbrDesc',
    image: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/yx7z8nsq_SBR.png'
  },
  { 
    id: 'turf', 
    name: 'artificialTurf', 
    description: 'artificialDesc',
    image: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/h6nrxna6_GRASS.png'
  },
  { 
    id: 'modular', 
    name: 'modularTiles', 
    description: 'modularDesc',
    image: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/2icxydlz_puzzle.png'
  },
  { 
    id: 'epdm', 
    name: 'epdmRubber', 
    description: 'epdmDesc',
    image: 'https://customer-assets.emergentagent.com/job_cage-landing/artifacts/xd4u6lz7_EPDM.png'
  }
];

export const upgradeOptions = [
  { id: 'led', name: 'ledLighting', description: 'ledDesc' },
  { id: 'fitness', name: 'fitnessModule', description: 'fitnessDesc' },
  { id: 'comfort', name: 'comfortPack', description: 'comfortDesc' }
];

export const videoUrls = [
  'https://www.youtube.com/embed/Xnc-drJsA6U',
  'https://www.youtube.com/embed/VM0gtnSax9s',
  'https://www.youtube.com/embed/-oqUa_TDvzE',
  'https://www.youtube.com/embed/dYmB4hPLbSY',
  'https://www.youtube.com/embed/eZ4-IBR2tOk'
];

// API form submission - sends to backend
export const submitContactForm = async (formData, configuratorData = null) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  
  try {
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company || null,
        message: formData.message,
        language: formData.language || 'cs',
        configurator: configuratorData
      }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.detail || 'Failed to submit form');
    }
    
    return data;
  } catch (error) {
    throw error;
  }
};
